import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getCookieConsentChoice,
  updateGoogleAdsConsent,
} from '../lib/googleAds';

function CookieConsent() {
  const [choice, setChoice] = useState(() => getCookieConsentChoice());

  if (choice) {
    return null;
  }

  const handleChoice = (nextChoice) => {
    updateGoogleAdsConsent(nextChoice);
    setChoice(nextChoice);
  };

  return (
    <aside className="cookie-consent" aria-label="Cookie consent">
      <div className="cookie-consent__copy">
        <h2>Cookie preferences</h2>
        <p>
          We use optional cookies for Google Ads measurement. Accept to help us understand which ads lead to signups, or reject to keep those cookies off.
        </p>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => handleChoice('rejected')}
        >
          Reject
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleChoice('accepted')}
        >
          Accept
        </button>
      </div>
    </aside>
  );
}

export default CookieConsent;
